import React from "react"

import "@styles/Header.css";

const ResultsNotFound = () => {
    return (
        <>
            <p>Nothing found... Try looking up a different word or phrase!</p>
        </>
    );
}

export default ResultsNotFound;

